<template>
    <teleport to="#modal">
        <Loading
            :visible="loading"
        >
        </Loading>
        <ModalAlert
            class="z-50"
            :azienda_id="id"
            v-model:visible="addAlertModalVisibility"
            :id="changeAlertId"
            v-model:result-status="resultStatus"
            @update:visible="reloadAttivita"
        ></ModalAlert>

        <CambiaStatoAlertModal
            class="z-50"
            v-model:visible="changeStateAlertModalVisibility"
            @reject="changeStateAlertModalVisibility = false"
            @confirm="changeStateAlertAutomatico"
            :riepilogo="riepilogo_stato_modal"
            :abilitato="alert_automatico?.abilitato"
            @close="changeStateAlertModalVisibility = false; riepilogo_stato_modal=false"
        ></CambiaStatoAlertModal>
    </teleport>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-10 flex justify-between">
                <Breadcrumbs :paths="paths"></Breadcrumbs>
                <div class="flex">
                    <NextButton variant="outline-secondary" @click="$router.back()"
                                class="w-48 hidden text-sm sm:block py-2 px-4">
                        &lt; Indietro
                    </NextButton>
                    <NextButton variant="primary" component="router-link" :to="{name: 'NuovoCliente'}"
                                class="w-48 ml-3 text-sm py-2 px-4 m-0 hidden sm:block">
                        + Aggiungi Cliente
                    </NextButton>
                </div>
            </div>
            <div class="hidden xl:grid max-w-screen-2xl m-auto grid-cols-3 gap-3">
                <div class="flex self-center text-3xl font-bold">Gestione Alert</div>
                <div class="col-span-2 flex justify-between items-center">
                    <div class="text-3xl font-bold">Attività</div>
                    <div v-show="azienda?.data_anniversario" class="bg-white p-4 flex-col">
                        <div class="text-sm flex justify-self-start">Anniversario</div>
                        <div class="text-3xl">{{ $filters.toDate(azienda?.data_anniversario) }}</div>
                    </div>
                </div>
            </div>
            <div class="max-w-screen-2xl m-auto grid grid-cols-1 xl:grid-cols-3 gap-3">
                <div>
                    <div class="flex xl:hidden self-center text-3xl font-bold py-4">Gestione Alert</div>
                    <div class="flex xl:hidden justify-self-start text-2xl py-4">Alert automatici</div>

                    <div v-if="alert_automatico" class="flex overflow-x-auto xl:grid xl:grid-cols-1 gap-3 py-4">
                        <AlertAutomatico :inizio="$filters.toDate(alert_automatico?.inizio_attivita)"
                                         :scadenza="$filters.toDate(alert_automatico?.scadenza)"
                                         :id="alert_automatico?.id"
                                         @changeState="changeStateAlert"
                                         :abilitato="alert_automatico?.abilitato"
                        >
                        </AlertAutomatico>
                    </div>
                    <div class="flex justify-between items-center py-4">
                        <div class="text-2xl">Alert manuali</div>
                        <NextButton variant="primary" @click="modalAddAlert"
                                    class="py-2 px-4 m-0">
                            + Aggiungi
                        </NextButton>
                    </div>
                    <div class="flex overflow-x-auto xl:grid xl:grid-cols-1 gap-3 py-4">
                        <AlertManuale
                            v-for="a in alerts_manuali"
                            :key="a.id"
                            :scadenza="$filters.toDate(a.scadenza)"
                            :descrizione="a.descrizione"
                            :id="a.id"
                            :abilitato="a.abilitato"
                            :updated_at="$filters.toDate(a.updated_at)"
                            @update="updateAlertManuale"
                            @stateChange="fetchAlert"
                            @delete="handleDelete"
                        >
                        </AlertManuale>
                    </div>
                </div>
                <div class="col-span-2">
                    <div v-if="permission_denied">
                        <Alert class="sticky top-0 z-10 bg-next-orange">Non hai i permessi sufficienti per poter creare un'attività
                        </Alert>
                    </div>
                    <div class="flex xl:hidden justify-between items-center">
                        <div class="text-3xl font-bold">Attività</div>
                        <div v-show="azienda?.data_anniversario" class="bg-white p-4 flex-col">
                            <div class="text-sm flex justify-self-start">Anniversario</div>
                            <div class="text-3xl">{{ $filters.toDate(azienda?.data_anniversario) }}</div>
                        </div>
                    </div>
                    <div class="py-4">
                        <div class="p-4 bg-white">
                            <NextEditor v-model="testo_attivita" class="flex flex-grow mr-3 min-h-[176px]"></NextEditor>
                            <div class="flex justify-end pt-3 gap-3 items-stretch">
                                <VueMultiselect v-model="tagsAutocomplete.selection"
                                                :options="tagsAutocomplete.options"
                                                :multiple="true"
                                                @search-change="tagsAutocomplete.search"
                                                :close-on-select="false"
                                                :clear-on-select="false"
                                                placeholder="Contatti"
                                                deselectLabel="Deseleziona"
                                                selectedLabel="Selezionato"
                                                selectLabel="Seleziona"
                                                class="next-vue-multiselect"
                                                track-by="id"
                                                label="full_name">
                                    <template v-slot:noResult>Nessun elemento trovato.</template>
                                    <template v-slot:tag="{option, remove}">
                                        <MultiselectOption @remove="remove(option)">
                                            {{option.full_name}}
                                        </MultiselectOption>
                                    </template>
                                </VueMultiselect>
                                <VueMultiselect v-model="attivitaAutocomplete.selection"
                                                :options="attivitaAutocomplete.options"
                                                @search-change="attivitaAutocomplete.search"
                                                placeholder="Attività"
                                                deselectLabel="Deseleziona"
                                                selectedLabel="Selezionato"
                                                selectLabel="Seleziona"
                                                class="next-vue-multiselect-single"
                                                track-by="id"
                                                label="descrizione">
                                </VueMultiselect>
                                <div class="flex flex-col lg:col-span-3">
                                    <Field :labelVisible="false" :required="true" :errors="[]"
                                           v-model="data_attivita" type="date">
                                    </Field>
                                </div>
                                <NextButton variant="primary"
                                            :disabled="!this.testo_attivita || !this.data_attivita || loading_creazione"
                                            @click="creaAttvita"
                                            class="py-1 px-4 flex items-center justify-center">
                                    <Spinner v-show="loading_creazione" class="w-3 mr-3 right-1"></Spinner>
                                    Salva
                                </NextButton>
                            </div>
                        </div>

                        <div v-for="a in attivita"
                             class="flex flex-col p-4 bg-white my-3">
                            <div v-html="a.descrizione" class="unreset border-b ">
                            </div>
                            <div>
                                <div class="flex items-center py-2">
                                    <span>Contatti:&nbsp;</span>
                                    <span v-for="t in a.tagged_contatti" :key="t.id" class="border p-1 mr-1">
                                        {{ t.full_name }}
                                    </span>

                                    <span>Attività:&nbsp;</span>
                                    <span v-show="a.attivita_crm_label" class="border p-1 mr-1">
                                        {{ a.attivita_crm_label }}
                                    </span>
                                </div>

                                <small class="pt-6"> Pubblicata il {{ $filters.toDateTime(a.created_at) }} da
                                    {{ a.owner }} | Data attività {{
                                        $filters.toDate(a.data_attivita) ? $filters.toDate(a.data_attivita) : '---'
                                    }}</small>
                            </div>
                        </div>
                        <InfiniteLoading @infinite="fetchNextPage" :identifier="infiniteIdentifier" style="min-height: 1px">
                            <template #complete>
                                <div class="text-center pb-3">Non ci sono altre attività.</div>
                            </template>
                        </InfiniteLoading>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import Topbar from "../components/Topbar.vue";
import InfiniteLoading from "v3-infinite-loading";
import ModalAlert from "@/components/ModalAlert.vue";
import ModalAlertAttivo from "@/components/ModalAlertAttivo.vue";
import meManager from "../api/Me";
import AlertAutomatico from "@/components/AlertAutomatico.vue";
import AlertManuale from "@/components/AlertManuale.vue";
import CambiaStatoAlertModal from "@/components/CambiaStatoAlertModal.vue";
import NextEditor from "@/components/NextEditor.vue";
import Editor from '@tinymce/tinymce-vue'
import Loading from "@/components/Loading.vue";
import Autocomplete from "@/setup/Autocomplete";
import contattiManager from "../api/Contatti";
import Alert from "@/components/Alert.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NextButton from "@/components/NextButton.vue";
import clientiManager from "../api/Clienti";
import Field from "@/components/Field.vue";
import moment from 'moment';
import attivitaManager from "../api/Attivita";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Spinner from "@/components/Spinner.vue";


@Options({
    name: 'Attivita',
    components: {
        Spinner,
        MultiselectOption,
        Alert,
        Field,
        Editor,
        Breadcrumbs,
        NextEditor,
        NextButton,
        AlertAutomatico,
        Topbar,
        InfiniteLoading,
        ModalAlert,
        ModalAlertAttivo,
        AlertManuale,
        CambiaStatoAlertModal,
        Loading,
    },
    props: {
        id: [String, Number]
    }
})
export default class Attivita extends Vue {

    tagsAutocomplete: any = setup(() => Autocomplete(contattiManager, true))
    attivitaAutocomplete: any = setup(() => Autocomplete(attivitaManager, true))

    id!: string | number

    infiniteIdentifier = false
    addAlertModalVisibility = false
    changeAlertModalVisibility = false
    changeAlertId = 0
    changeStateAlertModalVisibility = false
    resultStatus = 0

    testo_attivita = ''
    data_attivita = moment().format('YYYY-MM-DD')
    riepilogo_stato_modal = false
    loading = true
    loading_creazione = false
    permission_denied = false


    attivita: any[] = []
    azienda: any[] = []
    paginate: any = {}

    alert_automatico: any = null
    alerts_manuali: any[] = []

    fetchNextPage(state: any) {
        if (this.paginate.current_page) {
            if (this.paginate.current_page < this.paginate.last_page) {
                this.fetchAttivita(++this.paginate.current_page).then(() => {
                    state.loaded()
                }).catch(() => {
                    state.error()
                })
            } else {
                state.complete()
            }
        } else {
            state.loaded()
        }
    }

    creaAttvita() {
        this.loading_creazione = true
        this.permission_denied = false
        if (this.testo_attivita) {
            clientiManager.attivitaCrate(this.id, {
                descrizione: this.testo_attivita,
                data_attivita: this.data_attivita,
                tagged_contatti: this.tagsAutocomplete.selection.map((el: any) => el.id),
                attivita_crm_id: this.attivitaAutocomplete.selection.id || null
            }).then((response) => {
                this.testo_attivita = ''
                this.fetchAlert();
                return this.resetAttivita()
            }).catch((res) => {
                if (res.response.status == 403) {
                    this.permission_denied = true
                }
            }).finally(() => {
                this.loading_creazione = false
            })
        }
    }

    created() {
        this.loading = true
        this.tagsAutocomplete.addAjaxParam('cliente', this.id)
        clientiManager.cliente(this.id).then((response) => {
            this.azienda = response.data
        }).then(() => {
            return Promise.all([
                this.resetAttivita(),
                this.fetchAlert()
            ])
        }).finally(() => {
            this.loading = false
        })
    }

    fetchAttivita(page = 1, reset = false) {
        return clientiManager.attivita(this.id, {params:{page}}).then((response) => {
            const {data, ...pag} = response.data
            if (reset) {
                this.attivita.splice(0, this.attivita.length)
            }
            this.attivita.push(...data);
            this.paginate = pag;
        })
    }

    get paths() {
        return [
            {
                title: 'Home',
                name: 'Dashboard',
            },
            {
                title: 'Anagrafica',
                name: 'DettaglioAzienda',
                params: {id: this.id}
            },
            {
                title: 'Attività',
                name: 'Attivita',
            },
        ]
    }


    resetAttivita() {
        // this.infiniteIdentifier = !this.infiniteIdentifier
        return this.fetchAttivita(1, true)
    }

    fetchAlert() {
        return Promise.all([
            meManager.alertsAutomatici(this.id).then((response) => {
                this.alert_automatico = response.data
            }),
            meManager.alertsManuali(this.id).then((response) => {
                this.alerts_manuali = response.data
            })
        ])
    }

    reloadAttivita() {
        this.fetchAlert()
        this.addAlertModalVisibility = false
        this.changeAlertId = 0
    }

    modalAddAlert() {
        this.changeAlertId = 0
        this.addAlertModalVisibility = true
    }

    changeStateAlert() {
        this.changeStateAlertModalVisibility = true
    }

    changeStateAlertAutomatico() {
        clientiManager.alertAutomaticoToggle(this.id).then((res) => {
            this.alert_automatico = res.data
            this.riepilogo_stato_modal = true
        })
    }

    updateAlertManuale(id: number) {
        this.changeAlertId = id
        this.addAlertModalVisibility = true
    }

    handleDelete(id: number) {
        this.resultStatus = 3
        this.changeAlertId = id
        this.addAlertModalVisibility = true
    }

}
</script>


<style lang="scss">

</style>
